import { Prism, themes } from 'prism-react-renderer';

const PRISM_ALIAS = {
  text: 'markup',
  html: 'markup',
  htm: 'markup',
  xml: 'markup',
  vue: 'markup',
  svelte: 'markup',
  dockerfile: 'bash',
  docker: 'bash',
  sh: 'bash',
  zsh: 'bash',
  yml: 'yaml',
  proto: 'markup',
  hcl: 'markup',
  tf: 'markup',
  protobuf: 'markup',
  js: 'javascript',
  mjs: 'javascript',
  cjs: 'javascript',
  ts: 'tsx',
  py: 'python',
  rb: 'markup',
  php: 'markup',
  cs: 'markup',
  kt: 'kotlin',
  kts: 'kotlin',
  java: 'markup',
  sql: 'markup',
  scss: 'css',
  less: 'css',
  toml: 'markup',
  ini: 'markup',
};

export function prismLanguage(language) {
  const aliased = PRISM_ALIAS[language] || language;
  return (Prism.languages && Prism.languages[aliased]) ? aliased : 'markup';
}

export function codeHighlightTheme(dark) {
  // Same VS Code Dark+/Light pair the chat code blocks use, so keywords,
  // strings, and comments read like ChatGPT's canvas instead of washed gray.
  return dark ? themes.vsDark : themes.vsLight;
}
